import React from 'react'

const LogoOssanasur = () => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            //   xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="100%"
            viewBox="0 0 897 512"
            enable-background="new 0 0 897 512"
        //   xml:space="preserve"
        >
            {/* <g transform="translate(0.000000,4500.000000) scale(0.100000,-0.100000)" fill='#fff' stroke="none"> */}
            <path d="M16521 27939 c-6 -13 -40 -96 -76 -183 -35 -88 -69 -162 -74 -165 -5
-3 -93 -24 -195 -45 -102 -21 -186 -42 -186 -45 0 -4 67 -63 150 -131 173
-145 159 -107 134 -351 -8 -88 -14 -164 -12 -169 2 -5 79 38 172 95 165 102
169 104 200 91 17 -8 99 -43 182 -80 84 -36 154 -66 157 -66 2 0 -17 88 -44
195 l-49 196 130 146 c71 81 130 150 130 153 0 4 -90 12 -200 20 l-200 13 -95
161 c-52 89 -99 168 -104 175 -8 12 -12 10 -20 -10z" />
            <path d="M14655 27050 c-93 -171 -173 -317 -179 -326 -9 -12 -87 -23 -346 -49
-184 -19 -348 -35 -365 -37 -29 -3 -20 -14 220 -271 138 -147 251 -273 253
-280 1 -6 -31 -169 -72 -362 -41 -192 -73 -351 -71 -353 2 -2 151 67 332 153
l329 156 314 -185 c173 -102 316 -182 318 -177 2 5 -18 170 -43 367 l-46 359
33 29 c257 228 507 461 501 466 -4 4 -165 37 -357 74 -192 36 -351 67 -352 69
-1 1 -66 148 -144 327 -78 179 -145 331 -149 338 -5 9 -69 -100 -176 -298z" />
            <path d="M20010 26969 c-363 -37 -687 -131 -1021 -299 -730 -365 -1272 -989
-1525 -1755 -91 -276 -132 -517 -141 -825 -21 -704 191 -1343 637 -1920 96
-123 347 -375 480 -480 298 -236 698 -447 1036 -545 120 -35 284 -70 429 -92
170 -25 610 -25 780 0 437 65 809 200 1174 427 485 301 855 713 1111 1235 153
311 225 544 277 890 277 171 25 629 25 800 0 -52 345 -150 651 -306 950 -298 574
-722 998 -1296 1296 -329 171 -673 275 -1039 314 -155 16 -454 18 -596 4z
m551 -975 c573 -80 1096 -412 1423 -904 70 -105 174 -314 216 -435 142 -407
147 -862 14 -1264 -46 -139 -155 -361 -238 -485 -463 -689 -1271 -1034 -2061
-880 -288 56 -580 189 -828 376 -105 79 -316 290 -395 395 -285 377 -426 816
-409 1273 15 414 151 795 405 1137 86 114 272 299 392 389 291 218 630 359
966 403 117 15 394 12 515 -5z" />
            <path d="M9950 26909 c-310 -23 -694 -89 -981 -168 -715 -197 -1415 -567
-2009 -1061 -151 -125 -515 -487 -629 -625 -610 -737 -1000 -1572 -1151 -2463
-47 -277 -62 -456 -67 -801 -9 -566 35 -983 157 -1476 76 -309 217 -725 245
-725 25 0 585 223 960 383 344 146 1084 485 1107 506 4 4 -15 63 -43 131 -290
715 -273 1565 47 2274 365 812 1039 1413 1882 1679 569 180 1211 177 1787 -10
428 -139 816 -370 1168 -695 l98 -90 47 43 c351 318 807 777 1111 1118 200
224 382 444 379 457 -2 6 -54 58 -116 117 -715 674 -1659 1156 -2607 1331
-163 30 -417 62 -600 76 -163 12 -619 11 -785 -1z" />
            <path d="M25130 25375 c-559 -77 -1032 -459 -1174 -949 -76 -262 -52 -563 64
-801 107 -220 322 -423 588 -554 120 -60 151 -70 497 -175 412 -125 548 -184
664 -291 83 -77 104 -131 105 -260 1 -93 -1 -105 -31 -168 -65 -137 -196 -243
-348 -282 -79 -20 -232 -19 -316 3 -180 47 -335 213 -385 413 -21 84 -53 132
-111 166 l-48 28 -292 3 c-341 4 -358 1 -423 -67 -70 -71 -83 -137 -55 -261
65 -277 193 -509 395 -710 216 -217 475 -354 785 -417 137 -27 459 -25 617 5
429 81 776 293 977 598 79 118 121 214 159 353 23 88 25 114 26 301 1 284 -30
445 -125 634 -124 249 -376 473 -689 611 -52 23 -274 104 -493 179 -219 75
-430 152 -469 172 -86 43 -169 119 -200 183 -47 96 -21 242 57 329 90 100 244
157 410 150 121 -5 186 -30 266 -105 64 -59 90 -99 122 -188 l25 -70 343 -3
c228 -2 357 1 382 8 72 21 136 97 151 180 8 47 -15 133 -65 239 -133 285 -360
512 -649 650 -200 96 -492 133 -760 96z" />
            <path d="M28730 25375 c-557 -76 -1033 -461 -1175 -949 -73 -255 -51 -560 59
-791 103 -217 326 -431 580 -558 120 -60 151 -71 496 -176 429 -130 562 -188
679 -296 83 -77 104 -131 105 -260 1 -93 -1 -105 -31 -168 -22 -45 -56 -93
-100 -138 -105 -110 -228 -159 -395 -159 -176 0 -282 42 -399 159 -84 84 -125
158 -155 274 -22 89 -61 142 -127 173 -51 23 -57 24 -337 24 -175 0 -300 -4
-325 -11 -56 -15 -127 -91 -145 -153 -35 -126 70 -438 226 -674 78 -117 261
-299 384 -381 174 -115 370 -196 575 -238 138 -27 459 -25 620 5 416 78 770
292 965 583 76 114 110 181 143 284 40 120 57 241 57 394 -1 504 -174 834
-579 1105 -163 109 -290 161 -926 376 -237 80 -329 124 -401 192 -72 67 -97
122 -97 207 0 137 63 237 190 304 101 53 179 70 298 65 121 -5 186 -30 266
-105 64 -60 95 -108 124 -192 l22 -66 349 -3 c399 -3 406 -2 473 75 80 90 75
177 -24 380 -127 260 -345 477 -612 612 -208 104 -505 144 -783 106z" />
            <path d="M32930 25379 c-413 -42 -821 -213 -1161 -487 -95 -77 -278 -265 -351
-362 -229 -303 -374 -656 -423 -1024 -17 -134 -20 -425 -5 -561 75 -671 426
-1249 961 -1582 234 -146 496 -243 799 -295 169 -30 618 -32 775 -5 291 51
547 149 789 301 48 31 89 56 91 56 1 0 5 -18 9 -39 8 -50 60 -119 111 -148 40
-23 44 -23 357 -21 l316 3 43 30 c26 18 53 50 68 80 l26 49 0 1016 c0 1121 1
1107 -66 1367 -89 349 -279 693 -530 958 -324 341 -776 578 -1244 651 -123 19
-436 26 -565 13z m512 -952 c174 -46 329 -119 464 -220 78 -59 229 -216 281
-292 90 -133 170 -322 197 -464 63 -331 -4 -662 -191 -944 -62 -95 -217 -253
-306 -315 -147 -101 -330 -177 -501 -207 -129 -22 -343 -20 -467 5 -505 103
-898 501 -995 1008 -22 114 -22 319 0 435 71 375 322 710 663 885 210 108 366
143 603 138 125 -4 174 -9 252 -29z" />
            {/* </g> */}
        </svg>
    )
}

export default LogoOssanasur